import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Controls } from './controls/Controls';
import Modal from './Modal';

export default function CreateSiteOptionsModal({ isOpen, handleClose, onOptionSelect }) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Create New Site"
    >
      <div style={{ padding: '20px' }}>
        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
          How would you like to create this site?
        </Typography>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
        }}
        >
          <Controls.Button
            text="Start from Scratch"
            variant="contained"
            onClick={() => onOptionSelect('scratch')}
          />
          <Controls.Button
            text="Provide Schematic"
            variant="contained"
            onClick={() => onOptionSelect('schematic')}
          />
        </div>
      </div>
    </Modal>
  );
}

CreateSiteOptionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onOptionSelect: PropTypes.func.isRequired,
};
